import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ContentGuardService implements CanActivate {
    constructor(public router: Router) { }
    canActivate(): boolean {
        const token = localStorage.getItem('1');
        if (!token) {
            this.router.navigate([`/auth/login`]);
            return false;
        }
        return true;
    }
}
